import { render, staticRenderFns } from "./BtnLoad.yaml?vue&type=template&id=3f6db68e&component"
import script from "./BtnLoad.yaml?vue&type=script&lang=ts&component"
export * from "./BtnLoad.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports